var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconCategoryGrill(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 151,
    height: 150,
    viewBox: "0 0 151 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_465_9296)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M69.8803 46.7809C68.1782 45.0788 68.1782 42.3194 69.8803 40.6176L102.381 8.11675C104.083 6.4147 106.843 6.4147 108.544 8.11675C110.246 9.81881 110.246 12.5782 108.544 14.28L76.0435 46.7809C74.3415 48.4829 71.5821 48.4829 69.8803 46.7809Z",
    fill: "url(#paint0_linear_465_9296)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.152 15.313C103.844 15.0383 103.498 14.8089 103.122 14.6344C100.172 13.265 85.8788 7.11827 79.9126 13.5768C76.1967 17.5994 81.7482 24.3924 87.3947 29.6209C92.5509 34.3953 99.7173 35.2344 103.345 31.4989C107.454 27.2683 110.712 21.1562 104.152 15.313Z",
    fill: "url(#paint1_linear_465_9296)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.152 15.313C103.844 15.0383 103.498 14.8089 103.122 14.6344C100.172 13.265 85.8788 7.11827 79.9126 13.5768C76.1967 17.5994 81.7482 24.3924 87.3947 29.6209C92.5509 34.3956 110.712 21.1562 104.152 15.313Z",
    fill: "url(#paint2_linear_465_9296)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.2436 22.7006L85.8239 28.1203C86.3415 28.6317 86.8674 29.1332 87.3941 29.6209C91.7583 33.6617 97.5615 34.8826 101.441 32.8979L91.2436 22.7006Z",
    fill: "url(#paint3_linear_465_9296)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.851 21.7238C66.3116 24.6421 73.5213 29.7059 80.2384 36.423C86.9555 43.14 92.0193 50.35 94.9375 56.8103C96.5052 60.2806 101.801 59.8727 105.678 55.995C108.268 53.4056 109.447 49.9882 108.579 47.5494C106.017 40.3532 100.438 31.8644 92.6172 24.0441C84.7966 16.2235 76.3078 10.6441 69.1116 8.08265C66.6728 7.21442 63.2552 8.39354 60.6661 10.9829C56.7887 14.8603 56.3805 20.1562 59.851 21.7238Z",
    fill: "url(#paint4_linear_465_9296)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.0602 34.3703C90.8608 34.153 90.6487 33.9409 90.424 33.7338C85.8773 28.7782 74.4046 26.515 69.024 27.0015C72.7746 29.5997 76.5796 32.7635 80.2385 36.4224C86.9555 43.1394 92.0193 50.3494 94.9376 56.8097C96.5052 60.28 101.801 59.8721 105.678 55.9944C106.969 54.7038 107.909 53.2077 108.42 51.7294L91.0602 34.3703Z",
    fill: "url(#paint5_linear_465_9296)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.5469 27.6818C66.5469 27.6818 51.216 38.2018 46.3463 49.6612C41.4766 61.1206 70.1549 70.7024 76.4978 67.6956C82.8407 64.6888 92.3387 47.5947 92.3387 38.2021C92.3387 28.8094 69.8116 25.2409 66.5469 27.6818Z",
    fill: "url(#paint6_linear_465_9296)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.5468 27.6819C66.5468 27.6819 52.4738 37.3401 47.0121 48.2284C54.5883 52.0822 64.1612 54.0043 67.5097 52.4169C72.6315 49.989 79.8092 38.3769 82.3836 29.0504C75.9042 26.811 68.3353 26.3449 66.5468 27.6819Z",
    fill: "url(#paint7_linear_465_9296)"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M67.1347 33.2924C68.031 33.2924 68.7576 32.5658 68.7576 31.6695C68.7576 30.7731 68.031 30.0465 67.1347 30.0465C66.2383 30.0465 65.5117 30.7731 65.5117 31.6695C65.5117 32.5658 66.2383 33.2924 67.1347 33.2924Z",
    fill: "url(#paint8_linear_465_9296)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M64.9882 37.6506C65.6958 37.6506 66.2694 37.077 66.2694 36.3694C66.2694 35.6619 65.6958 35.0883 64.9882 35.0883C64.2806 35.0883 63.707 35.6619 63.707 36.3694C63.707 37.077 64.2806 37.6506 64.9882 37.6506Z",
    fill: "url(#paint9_linear_465_9296)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M70.676 37.1186C71.1026 37.1186 71.4484 36.7728 71.4484 36.3462C71.4484 35.9196 71.1026 35.5739 70.676 35.5739C70.2495 35.5739 69.9037 35.9196 69.9037 36.3462C69.9037 36.7728 70.2495 37.1186 70.676 37.1186Z",
    fill: "url(#paint10_linear_465_9296)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M75.7911 32.4124C76.4535 32.4124 76.9905 31.8754 76.9905 31.213C76.9905 30.5505 76.4535 30.0135 75.7911 30.0135C75.1287 30.0135 74.5917 30.5505 74.5917 31.213C74.5917 31.8754 75.1287 32.4124 75.7911 32.4124Z",
    fill: "url(#paint11_linear_465_9296)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M72.145 33.293C72.6679 33.293 73.0918 32.8691 73.0918 32.3462C73.0918 31.8234 72.6679 31.3995 72.145 31.3995C71.6221 31.3995 71.1982 31.8234 71.1982 32.3462C71.1982 32.8691 71.6221 33.293 72.145 33.293Z",
    fill: "url(#paint12_linear_465_9296)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M74.96 36.0379C75.2753 36.0379 75.5309 35.7824 75.5309 35.4671C75.5309 35.1518 75.2753 34.8962 74.96 34.8962C74.6448 34.8962 74.3892 35.1518 74.3892 35.4671C74.3892 35.7824 74.6448 36.0379 74.96 36.0379Z",
    fill: "url(#paint13_linear_465_9296)"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M64.6981 37.4235C60.5549 37.4235 56.6316 38.1897 53.1275 39.5556C50.374 42.6432 47.8566 46.1068 46.3463 49.6612C41.4766 61.1206 70.1549 70.7023 76.4978 67.6956C80.5478 65.7759 85.8831 58.1135 89.2119 50.3794C85.0193 42.7453 75.6243 37.4235 64.6981 37.4235Z",
    fill: "url(#paint14_linear_465_9296)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.6852 55.5464C80.9388 47.6714 70.4029 42.3903 58.3449 42.3903C55.507 42.3903 52.7535 42.6838 50.1264 43.2338C48.6029 45.2964 47.282 47.4611 46.3473 49.6611C41.4776 61.1206 70.1558 70.7023 76.4988 67.6956C79.6332 66.2097 83.537 61.2832 86.6852 55.5464Z",
    fill: "url(#paint15_linear_465_9296)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.4791 54.6903L57.1156 64.0538C64.4903 67.5388 73.3121 69.2056 76.4983 67.6953C77.0809 67.4191 77.69 67.0238 78.3159 66.5268L66.4791 54.6903Z",
    fill: "url(#paint16_linear_465_9296)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.4982 50.0764C37.9588 52.9947 45.1685 58.0585 51.8856 64.7756C58.6026 71.4926 63.6665 78.7026 66.5847 85.1629C68.1524 88.6332 73.4482 88.2253 77.3256 84.3476C79.915 81.7582 81.0941 78.3409 80.2259 75.902C77.6644 68.7058 72.085 60.217 64.2644 52.3967C56.4438 44.5761 47.955 38.9967 40.7591 36.4353C38.3203 35.567 34.9027 36.7461 32.3135 39.3355C28.4359 43.2129 28.0279 48.5088 31.4982 50.0764Z",
    fill: "url(#paint17_linear_465_9296)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.3262 84.3477C79.9156 81.7582 81.0947 78.3409 80.2265 75.9021C80.2062 75.8447 80.1838 75.7868 80.1632 75.7294L65.115 60.6812C64.6941 60.2485 64.2435 59.8162 63.7594 59.3847C63.2485 58.9297 62.6762 58.5497 62.0538 58.2609C58.5829 56.65 45.6376 51.0503 34.8844 51.7697C40.4194 54.7853 46.3212 59.2106 51.8862 64.7756C58.6032 71.4927 63.6671 78.7027 66.5853 85.1629C68.1526 88.6332 73.4485 88.225 77.3262 84.3477Z",
    fill: "url(#paint18_linear_465_9296)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.7592 59.3847C63.2483 58.9297 62.676 58.5497 62.0536 58.2609C57.166 55.9923 33.4889 45.81 23.6057 56.5088C17.4501 63.1723 26.6463 74.4253 35.9998 83.0864C44.5413 90.9956 56.4128 92.3853 62.4219 86.1976C69.2283 79.1888 74.6257 69.0641 63.7592 59.3847Z",
    fill: "url(#paint19_linear_465_9296)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.7592 59.3847C63.2483 58.9297 62.676 58.5497 62.0536 58.2609C57.166 55.9923 33.4889 45.81 23.6057 56.5088C17.4501 63.1723 26.6463 74.4253 35.9998 83.0864C44.5416 90.9956 74.6257 69.0641 63.7592 59.3847Z",
    fill: "url(#paint20_linear_465_9296)"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M53.4877 76.8926C53.9142 76.8926 54.26 76.5468 54.26 76.1203C54.26 75.6937 53.9142 75.3479 53.4877 75.3479C53.0611 75.3479 52.7153 75.6937 52.7153 76.1203C52.7153 76.5468 53.0611 76.8926 53.4877 76.8926Z",
    fill: "url(#paint21_linear_465_9296)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M58.6037 72.1864C59.2661 72.1864 59.8031 71.6494 59.8031 70.987C59.8031 70.3246 59.2661 69.7876 58.6037 69.7876C57.9413 69.7876 57.4043 70.3246 57.4043 70.987C57.4043 71.6494 57.9413 72.1864 58.6037 72.1864Z",
    fill: "url(#paint22_linear_465_9296)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M54.9576 73.0674C55.4805 73.0674 55.9044 72.6435 55.9044 72.1206C55.9044 71.5977 55.4805 71.1738 54.9576 71.1738C54.4347 71.1738 54.0109 71.5977 54.0109 72.1206C54.0109 72.6435 54.4347 73.0674 54.9576 73.0674Z",
    fill: "url(#paint23_linear_465_9296)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M57.7723 75.8123C58.0876 75.8123 58.3432 75.5567 58.3432 75.2414C58.3432 74.9261 58.0876 74.6705 57.7723 74.6705C57.457 74.6705 57.2014 74.9261 57.2014 75.2414C57.2014 75.5567 57.457 75.8123 57.7723 75.8123Z",
    fill: "url(#paint24_linear_465_9296)"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M36.0001 83.0865C41.6601 88.3274 48.7807 90.7024 54.6904 89.91L40.721 75.9406L34.7501 81.9115C35.1654 82.308 35.5825 82.7 36.0001 83.0865Z",
    fill: "url(#paint25_linear_465_9296)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.48747 71.1541C12.6072 74.7317 20.6801 80.6582 28.3413 88.3197C36.0025 95.9811 41.9292 104.054 45.5069 111.173C47.4286 114.998 53.0681 114.933 56.9457 111.056C59.5351 108.467 60.5569 104.892 59.4563 102.221C56.2086 94.3385 49.6404 84.8608 40.7204 75.9405C31.8004 67.0205 22.3228 60.452 14.4404 57.2047C11.7689 56.1041 8.19423 57.1258 5.60482 59.7153C1.72747 63.5926 1.66276 69.232 5.48747 71.1541Z",
    fill: "url(#paint26_radial_465_9296)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.3415 88.3197C36.0029 95.9812 41.9294 104.054 45.5071 111.174C47.4288 114.998 53.0682 114.934 56.9459 111.056C58.5212 109.481 59.5118 107.541 59.8018 105.662L35.4003 81.2609C33.6982 79.5588 30.9388 79.5588 29.2371 81.2609L25.1997 85.2982C26.2521 86.2732 27.3009 87.2788 28.3415 88.3197Z",
    fill: "url(#paint27_linear_465_9296)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.97772 114.684C0.275657 112.981 0.275657 110.222 1.97772 108.52L29.2371 81.2609C30.9392 79.5588 33.6986 79.5588 35.4004 81.2609C37.1024 82.9629 37.1024 85.7223 35.4004 87.4241L8.14095 114.684C6.43919 116.386 3.67977 116.386 1.97772 114.684Z",
    fill: "url(#paint28_linear_465_9296)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.557 74.0127C106.855 72.3106 106.855 69.5512 108.557 67.8494L141.058 35.3483C142.76 33.6462 145.519 33.6462 147.221 35.3483C148.923 37.0503 148.923 39.8097 147.221 41.5115L114.72 74.0127C113.018 75.7144 110.259 75.7144 108.557 74.0127Z",
    fill: "url(#paint29_linear_465_9296)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.434 43.3097C113.096 46.1547 119.516 50.8679 125.608 56.9609C131.701 63.0538 136.414 69.4735 139.26 75.1356C140.788 78.177 145.273 78.1259 148.356 75.042C150.415 72.9829 151.228 70.14 150.353 68.0156C147.77 61.7473 142.547 54.21 135.453 47.1165C128.359 40.0226 120.822 34.7991 114.554 32.2165C112.429 31.3412 109.586 32.1538 107.527 34.2129C104.444 37.2967 104.392 41.7815 107.434 43.3097Z",
    fill: "url(#paint30_radial_465_9296)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.875 44.6285C114.903 47.5168 120.376 51.728 125.609 56.9609C131.702 63.0535 136.415 69.4735 139.26 75.1356C140.788 78.1771 145.273 78.1259 148.357 75.0421C150.416 72.983 151.229 70.14 150.353 68.0156C149.803 66.6806 149.127 65.2856 148.345 63.8521L138.234 53.7418C137.776 53.263 137.281 52.7844 136.745 52.3074C136.235 51.8524 135.662 51.4724 135.04 51.1835C131.782 49.6718 120.178 44.6462 109.875 44.6285Z",
    fill: "url(#paint31_linear_465_9296)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.744 52.3074C136.233 51.8524 135.661 51.4724 135.039 51.1835C130.151 48.915 106.474 38.7326 96.5907 49.4315C90.4351 56.095 99.6313 67.3479 108.985 76.0091C117.526 83.9182 129.398 85.3079 135.407 79.1203C142.213 72.1115 147.611 61.9868 136.744 52.3074Z",
    fill: "url(#paint32_linear_465_9296)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.744 52.3074C136.233 51.8524 135.661 51.4724 135.039 51.1835C130.151 48.915 106.474 38.7326 96.5907 49.4315C90.4351 56.095 99.6313 67.348 108.985 76.0091C117.527 83.9183 147.611 61.9868 136.744 52.3074Z",
    fill: "url(#paint33_linear_465_9296)"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M126.473 69.8153C126.899 69.8153 127.245 69.4695 127.245 69.0429C127.245 68.6164 126.899 68.2706 126.473 68.2706C126.046 68.2706 125.7 68.6164 125.7 69.0429C125.7 69.4695 126.046 69.8153 126.473 69.8153Z",
    fill: "url(#paint34_linear_465_9296)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M131.588 65.1091C132.251 65.1091 132.788 64.5721 132.788 63.9097C132.788 63.2473 132.251 62.7103 131.588 62.7103C130.926 62.7103 130.389 63.2473 130.389 63.9097C130.389 64.5721 130.926 65.1091 131.588 65.1091Z",
    fill: "url(#paint35_linear_465_9296)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M127.942 65.9897C128.465 65.9897 128.889 65.5658 128.889 65.043C128.889 64.5201 128.465 64.0962 127.942 64.0962C127.419 64.0962 126.996 64.5201 126.996 65.043C126.996 65.5658 127.419 65.9897 127.942 65.9897Z",
    fill: "url(#paint36_linear_465_9296)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M130.757 68.7347C131.073 68.7347 131.328 68.4791 131.328 68.1638C131.328 67.8485 131.073 67.5929 130.757 67.5929C130.442 67.5929 130.186 67.8485 130.186 68.1638C130.186 68.4791 130.442 68.7347 130.757 68.7347Z",
    fill: "url(#paint37_linear_465_9296)"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M129.196 82.5547L116.838 70.197L110.074 76.9611C116.049 81.9591 123.38 83.9358 129.196 82.5547Z",
    fill: "url(#paint38_linear_465_9296)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.8792 65.6038C88.3398 68.5221 95.5495 73.5859 102.267 80.303C108.984 87.02 114.047 94.23 116.966 100.69C118.533 104.161 123.829 103.753 127.707 99.875C130.296 97.2856 131.475 93.8683 130.607 91.4294C128.045 84.2333 122.466 75.7444 114.645 67.9241C106.825 60.1035 98.336 54.5241 91.1401 51.9627C88.7013 51.0944 85.2836 52.2735 82.6945 54.863C78.8169 58.7403 78.4086 64.0362 81.8792 65.6038Z",
    fill: "url(#paint39_linear_465_9296)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.183 78.0076C113.911 77.7053 113.606 77.4194 113.258 77.1565C104.558 70.5818 88.9847 69.1891 88.9847 69.1891C88.8433 69.1706 88.6818 69.1759 88.5056 69.2C93.0656 72.0656 97.7756 75.8123 102.266 80.3029C108.983 87.02 114.047 94.23 116.965 100.69C118.533 104.161 123.829 103.753 127.706 99.875C129.304 98.2773 130.362 96.3647 130.737 94.5609L114.183 78.0076Z",
    fill: "url(#paint40_linear_465_9296)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.9849 69.1892C88.9849 69.1892 104.558 70.5818 113.258 77.1565C121.958 83.7312 106.354 103.23 100.533 103.671C94.7119 104.111 80.174 95.2586 75.8313 88.163C71.4887 81.0674 85.5758 68.7412 88.9849 69.1892Z",
    fill: "url(#paint41_linear_465_9296)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.9848 69.1891C88.9848 69.1891 103.281 70.4686 112.13 76.3586C108.619 82.5088 102.821 88.0533 99.7474 88.2859C95.0471 88.6415 84.6648 82.9383 78.5542 76.9933C82.0454 72.5318 87.1171 68.9436 88.9848 69.1891Z",
    fill: "url(#paint42_linear_465_9296)"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M86.2263 74.6233C87.1227 74.6233 87.8493 73.8967 87.8493 73.0004C87.8493 72.1041 87.1227 71.3774 86.2263 71.3774C85.33 71.3774 84.6034 72.1041 84.6034 73.0004C84.6034 73.8967 85.33 74.6233 86.2263 74.6233Z",
    fill: "url(#paint43_linear_465_9296)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M84.08 78.9816C84.7876 78.9816 85.3612 78.408 85.3612 77.7004C85.3612 76.9928 84.7876 76.4192 84.08 76.4192C83.3724 76.4192 82.7988 76.9928 82.7988 77.7004C82.7988 78.408 83.3724 78.9816 84.08 78.9816Z",
    fill: "url(#paint44_linear_465_9296)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M89.7678 78.4495C90.1944 78.4495 90.5402 78.1037 90.5402 77.6771C90.5402 77.2506 90.1944 76.9048 89.7678 76.9048C89.3413 76.9048 88.9955 77.2506 88.9955 77.6771C88.9955 78.1037 89.3413 78.4495 89.7678 78.4495Z",
    fill: "url(#paint45_linear_465_9296)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M94.8829 73.7433C95.5453 73.7433 96.0823 73.2063 96.0823 72.5439C96.0823 71.8815 95.5453 71.3445 94.8829 71.3445C94.2205 71.3445 93.6835 71.8815 93.6835 72.5439C93.6835 73.2063 94.2205 73.7433 94.8829 73.7433Z",
    fill: "url(#paint46_linear_465_9296)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M91.2368 74.6239C91.7597 74.6239 92.1836 74.2 92.1836 73.6771C92.1836 73.1542 91.7597 72.7303 91.2368 72.7303C90.7139 72.7303 90.29 73.1542 90.29 73.6771C90.29 74.2 90.7139 74.6239 91.2368 74.6239Z",
    fill: "url(#paint47_linear_465_9296)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M94.0517 77.3689C94.367 77.3689 94.6226 77.1133 94.6226 76.798C94.6226 76.4827 94.367 76.2271 94.0517 76.2271C93.7364 76.2271 93.4808 76.4827 93.4808 76.798C93.4808 77.1133 93.7364 77.3689 94.0517 77.3689Z",
    fill: "url(#paint48_linear_465_9296)"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M94.7802 75.7577C97.6746 73.9862 100.769 72.8877 103.848 72.4215C107.2 73.5768 110.559 75.1171 113.258 77.1562C121.957 83.7309 106.353 103.23 100.533 103.67C96.8158 103.952 89.5461 100.444 83.6452 96.025C83.0449 88.4659 87.1475 80.4292 94.7802 75.7577Z",
    fill: "url(#paint49_linear_465_9296)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.7997 98.8482C88.1729 90.4426 93.0914 81.9485 101.515 76.7935C103.497 75.5803 105.556 74.6247 107.646 73.9171C109.664 74.8238 111.588 75.8944 113.258 77.1565C121.957 83.7312 106.354 103.23 100.533 103.671C97.6559 103.888 92.6512 101.836 87.7997 98.8482Z",
    fill: "url(#paint50_linear_465_9296)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.5396 93.1088C95.2258 92.7858 94.8896 92.4635 94.5285 92.1417C94.1488 91.8035 93.7232 91.5208 93.2605 91.3064C90.9008 90.2114 82.6511 86.6364 75.144 86.4417C75.2732 87.0408 75.4973 87.6176 75.8311 88.1632C80.1737 95.2588 94.7114 104.111 100.533 103.671C101.549 103.594 102.864 102.934 104.296 101.866L95.5396 93.1088Z",
    fill: "url(#paint51_linear_465_9296)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.5284 92.1418C94.1487 91.8035 93.7231 91.5209 93.2605 91.3062C89.627 89.6197 72.0249 82.05 64.6775 90.0038C60.1014 94.9576 66.9378 103.323 73.8917 109.762C80.2417 115.642 89.067 116.675 93.5343 112.075C98.5943 106.865 102.607 99.3376 94.5284 92.1418Z",
    fill: "url(#paint52_linear_465_9296)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.5284 92.1418C94.1487 91.8035 93.7231 91.5209 93.2605 91.3062C89.6269 89.6197 72.0249 82.05 64.6775 90.0038C60.1014 94.9576 66.9378 103.323 73.8917 109.762C80.2417 115.642 102.607 99.3376 94.5284 92.1418Z",
    fill: "url(#paint53_linear_465_9296)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.8919 109.762C79.781 115.215 87.7966 116.496 92.4931 112.984L81.0393 101.531L73.3319 109.238C73.5184 109.414 73.7051 109.589 73.8919 109.762Z",
    fill: "url(#paint54_linear_465_9296)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.2833 101.221C56.2062 103.602 62.7127 107.962 68.6598 113.909C74.6068 119.856 78.9671 126.363 81.348 132.286C82.6268 135.468 87.6427 134.779 91.5201 130.902C94.1095 128.312 95.4168 125.023 94.7383 122.774C92.7359 116.137 87.9627 108.454 81.0386 101.53C74.1145 94.6062 66.4321 89.8329 59.7951 87.8306C57.5456 87.152 54.2565 88.4594 51.6671 91.0488C47.79 94.9265 47.1015 99.9423 50.2833 101.221Z",
    fill: "url(#paint55_linear_465_9296)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.0772 108.492C72.3751 106.79 69.6157 106.79 67.914 108.492L65.4792 110.927C66.5525 111.872 67.6151 112.865 68.6601 113.909C74.6072 119.856 78.9675 126.363 81.3484 132.286C82.6272 135.468 87.6431 134.779 91.5204 130.902C92.3981 130.024 93.1242 129.066 93.6798 128.095L74.0772 108.492Z",
    fill: "url(#paint56_linear_465_9296)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.6542 141.915C38.9522 140.213 38.9522 137.453 40.6542 135.752L67.9136 108.492C69.6157 106.79 72.3751 106.79 74.0769 108.492C75.7789 110.194 75.7789 112.954 74.0769 114.656L46.8175 141.915C45.1154 143.617 42.3563 143.617 40.6542 141.915Z",
    fill: "url(#paint57_linear_465_9296)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_465_9296",
    x1: 87.3486,
    y1: 25.6477,
    x2: 99.2015,
    y2: 37.5005,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A57C52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1339,
    stopColor: "#A26C4A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5155,
    stopColor: "#994336"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8174,
    stopColor: "#942A2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#922125"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_465_9296",
    x1: 94.4134,
    y1: 17.2567,
    x2: 89.246,
    y2: 30.2313,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDECF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3791,
    stopColor: "#FDC4B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7655,
    stopColor: "#FBAE97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAA68E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_465_9296",
    x1: 92.1015,
    y1: 19.1015,
    x2: 91.0921,
    y2: 45.2261,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDECF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3791,
    stopColor: "#FDC4B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7655,
    stopColor: "#FBAE97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAA68E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_465_9296",
    x1: 103.085,
    y1: 39.962,
    x2: 88.5639,
    y2: 25.4406,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F82814",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2454,
    stopColor: "#F12817",
    stopOpacity: 0.245
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6052,
    stopColor: "#DD2820",
    stopOpacity: 0.605
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0272D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_465_9296",
    x1: 91.7884,
    y1: 24.8729,
    x2: 78.5213,
    y2: 38.14,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BADA00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2269,
    stopColor: "#B0CE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6378,
    stopColor: "#95AE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#798C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_465_9296",
    x1: 104.297,
    y1: 57.0662,
    x2: 75.3796,
    y2: 28.1486,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#798C00",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6542,
    stopColor: "#556100",
    stopOpacity: 0.654
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#464F00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_465_9296",
    x1: 65.6025,
    y1: 35.1556,
    x2: 76.654,
    y2: 67.5612,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A57C52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1339,
    stopColor: "#A26C4A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5155,
    stopColor: "#994336"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8174,
    stopColor: "#942A2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#922125"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_465_9296",
    x1: 64.1259,
    y1: 31.2766,
    x2: 66.4541,
    y2: 61.2331,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A57C52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1339,
    stopColor: "#A26C4A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5155,
    stopColor: "#994336"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8174,
    stopColor: "#942A2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#922125"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_465_9296",
    x1: 69.0475,
    y1: 32.9789,
    x2: 63.7323,
    y2: 27.4353,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#42210B",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#42210B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_465_9296",
    x1: 66.5432,
    y1: 37.3027,
    x2: 62.3474,
    y2: 32.9264,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#42210B",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#42210B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_465_9296",
    x1: 71.6933,
    y1: 36.7186,
    x2: 69.1637,
    y2: 34.0802,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#42210B",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#42210B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_465_9296",
    x1: 75.6199,
    y1: 33.5622,
    x2: 76.0569,
    y2: 27.8996,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#42210B",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#42210B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_465_9296",
    x1: 72.0015,
    y1: 34.3125,
    x2: 72.3465,
    y2: 29.842,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#42210B",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#42210B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_465_9296",
    x1: 74.8617,
    y1: 36.8642,
    x2: 75.0696,
    y2: 34.1691,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#42210B",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#42210B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_465_9296",
    x1: 78.4831,
    y1: 44.7388,
    x2: 103.835,
    y2: 28.1826,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#42210B",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#42210B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_465_9296",
    x1: 75.3364,
    y1: 47.6532,
    x2: 97.4038,
    y2: 33.242,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#42210B",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#42210B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_465_9296",
    x1: 79.928,
    y1: 77.5029,
    x2: 63.4115,
    y2: 60.9865,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#42210B",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#42210B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_465_9296",
    x1: 63.4356,
    y1: 53.2256,
    x2: 50.1688,
    y2: 66.4923,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD945"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3043,
    stopColor: "#FFCD3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8558,
    stopColor: "#FFAD2B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA325"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_465_9296",
    x1: 83.2629,
    y1: 90.5177,
    x2: 29.7532,
    y2: 37.0079,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F82814",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0272D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_465_9296",
    x1: 52.8642,
    y1: 54.5847,
    x2: 38.5845,
    y2: 80.4538,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A57C52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1339,
    stopColor: "#A26C4A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5155,
    stopColor: "#994336"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8174,
    stopColor: "#942A2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#922125"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_465_9296",
    x1: 44.5939,
    y1: 56.9844,
    x2: 39.4201,
    y2: 98.9959,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A57C52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1339,
    stopColor: "#A26C4A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5155,
    stopColor: "#994336"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8174,
    stopColor: "#942A2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#922125"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_465_9296",
    x1: 54.5236,
    y1: 76.487,
    x2: 51.9937,
    y2: 73.8487,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#42210B",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#42210B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_465_9296",
    x1: 58.4203,
    y1: 73.3554,
    x2: 58.8574,
    y2: 67.6926,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#42210B",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#42210B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_465_9296",
    x1: 54.8019,
    y1: 74.1053,
    x2: 55.1471,
    y2: 69.6349,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#42210B",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#42210B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_465_9296",
    x1: 57.662,
    y1: 76.657,
    x2: 57.8699,
    y2: 73.9619,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#42210B",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#42210B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_465_9296",
    x1: 61.1728,
    y1: 102.364,
    x2: 39.2519,
    y2: 80.4427,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#42210B",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#42210B"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint26_radial_465_9296",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23.9034 93.7091) rotate(-135) scale(43.5634 20.7034)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6359"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4845,
    stopColor: "#FF6157"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6591,
    stopColor: "#FE5C50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7835,
    stopColor: "#FD5145"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.884,
    stopColor: "#FB4334"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9692,
    stopColor: "#F9311E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F82814"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_465_9296",
    x1: 52.8629,
    y1: 108.811,
    x2: 27.8715,
    y2: 83.8191,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F82814",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0272D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_465_9296",
    x1: 16.8361,
    y1: 96.1603,
    x2: 28.6889,
    y2: 108.013,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A57C52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1339,
    stopColor: "#A26C4A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5155,
    stopColor: "#994336"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8174,
    stopColor: "#942A2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#922125"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_465_9296",
    x1: 126.019,
    y1: 52.8749,
    x2: 137.872,
    y2: 64.728,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A57C52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1339,
    stopColor: "#A26C4A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5155,
    stopColor: "#994336"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8174,
    stopColor: "#942A2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#922125"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint30_radial_465_9296",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(122.034 61.2631) rotate(-135) scale(34.6442 16.4646)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6359"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4845,
    stopColor: "#FF6157"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6591,
    stopColor: "#FE5C50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7835,
    stopColor: "#FD5145"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.884,
    stopColor: "#FB4334"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9692,
    stopColor: "#F9311E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F82814"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_465_9296",
    x1: 150.74,
    y1: 67.2853,
    x2: 141.117,
    y2: 64.4915,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F82814",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0272D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_465_9296",
    x1: 125.849,
    y1: 47.5071,
    x2: 111.57,
    y2: 73.3762,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A57C52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1339,
    stopColor: "#A26C4A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5155,
    stopColor: "#994336"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8174,
    stopColor: "#942A2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#922125"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_465_9296",
    x1: 117.579,
    y1: 49.9071,
    x2: 112.405,
    y2: 91.9186,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A57C52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1339,
    stopColor: "#A26C4A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5155,
    stopColor: "#994336"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8174,
    stopColor: "#942A2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#922125"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_465_9296",
    x1: 127.485,
    y1: 69.3872,
    x2: 124.955,
    y2: 66.7489,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#42210B",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#42210B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_465_9296",
    x1: 131.443,
    y1: 66.2804,
    x2: 131.88,
    y2: 60.6176,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#42210B",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#42210B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_465_9296",
    x1: 127.824,
    y1: 67.0303,
    x2: 128.169,
    y2: 62.5602,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#42210B",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#42210B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_465_9296",
    x1: 130.684,
    y1: 69.582,
    x2: 130.892,
    y2: 66.8869,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#42210B",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#42210B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_465_9296",
    x1: 132.973,
    y1: 93.0958,
    x2: 113.837,
    y2: 73.9606,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#42210B",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#42210B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_465_9296",
    x1: 113.817,
    y1: 68.753,
    x2: 100.55,
    y2: 82.02,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BADA00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2269,
    stopColor: "#B0CE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6378,
    stopColor: "#95AE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#798C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_465_9296",
    x1: 126.472,
    y1: 100.424,
    x2: 93.6627,
    y2: 67.6153,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#798C00",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6542,
    stopColor: "#556100",
    stopOpacity: 0.654
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#464F00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_465_9296",
    x1: 93.3268,
    y1: 74.3351,
    x2: 99.9253,
    y2: 103.774,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A57C52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1339,
    stopColor: "#A26C4A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5155,
    stopColor: "#994336"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8174,
    stopColor: "#942A2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#922125"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_465_9296",
    x1: 92.388,
    y1: 70.8498,
    x2: 104.489,
    y2: 94.5794,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A57C52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1339,
    stopColor: "#A26C4A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5155,
    stopColor: "#994336"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8174,
    stopColor: "#942A2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#922125"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_465_9296",
    x1: 88.1476,
    y1: 74.2914,
    x2: 82.8324,
    y2: 68.748,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#42210B",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#42210B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_465_9296",
    x1: 85.6434,
    y1: 78.6151,
    x2: 81.4473,
    y2: 74.239,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#42210B",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#42210B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_465_9296",
    x1: 90.7936,
    y1: 78.031,
    x2: 88.2637,
    y2: 75.3927,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#42210B",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#42210B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_465_9296",
    x1: 94.718,
    y1: 74.9157,
    x2: 95.155,
    y2: 69.253,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#42210B",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#42210B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_465_9296",
    x1: 91.0994,
    y1: 75.6657,
    x2: 91.4446,
    y2: 71.1953,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#42210B",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#42210B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear_465_9296",
    x1: 93.9595,
    y1: 78.2175,
    x2: 94.1674,
    y2: 75.5223,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#42210B",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#42210B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear_465_9296",
    x1: 88.7337,
    y1: 87.6851,
    x2: 63.718,
    y2: 86.9505,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#42210B",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#42210B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint50_linear_465_9296",
    x1: 92.3857,
    y1: 88.4843,
    x2: 70.7766,
    y2: 87.8498,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#42210B",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#42210B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint51_linear_465_9296",
    x1: 105.855,
    y1: 111.16,
    x2: 89.0135,
    y2: 94.3185,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#42210B",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#42210B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint52_linear_465_9296",
    x1: 82.5136,
    y1: 94.5251,
    x2: 76.1499,
    y2: 110.503,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDECF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3791,
    stopColor: "#FDC4B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7655,
    stopColor: "#FBAE97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAA68E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint53_linear_465_9296",
    x1: 79.6662,
    y1: 96.7966,
    x2: 78.4234,
    y2: 128.969,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDECF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3791,
    stopColor: "#FDC4B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7655,
    stopColor: "#FBAE97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAA68E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint54_linear_465_9296",
    x1: 88.6393,
    y1: 116.838,
    x2: 77.1854,
    y2: 105.384,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F82814",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2454,
    stopColor: "#F12817",
    stopOpacity: 0.245
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6052,
    stopColor: "#DD2820",
    stopOpacity: 0.605
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0272D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint55_linear_465_9296",
    x1: 80.2785,
    y1: 102.428,
    x2: 67.0114,
    y2: 115.695,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD945"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3043,
    stopColor: "#FFCD3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8558,
    stopColor: "#FFAD2B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA325"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint56_linear_465_9296",
    x1: 86.689,
    y1: 129.549,
    x2: 55.4151,
    y2: 98.2755,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F82814",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0272D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint57_linear_465_9296",
    x1: 55.5067,
    y1: 123.387,
    x2: 67.3598,
    y2: 135.241,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A57C52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1339,
    stopColor: "#A26C4A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5155,
    stopColor: "#994336"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8174,
    stopColor: "#942A2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#922125"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_465_9296"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 150,
    height: 150,
    fill: "white",
    transform: "translate(0.701416 0.0158691)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCategoryGrill);
export default __webpack_public_path__ + "static/media/icon-category-grill.b046bb16.svg";
export { ForwardRef as ReactComponent };